'use client';

import { c as _c } from "react/compiler-runtime";
import { Toast } from '@base-ui/react/toast';
import type { SnackbarApi } from './types';
export function useSnackbar() {
  const $ = _c(2);
  const manager = Toast.useToastManager();
  let t0;
  if ($[0] !== manager) {
    t0 = {
      error: t1 => {
        const {
          title,
          timeout
        } = t1;
        manager.add({
          title,
          type: "error",
          priority: "high",
          ...(timeout !== undefined && {
            timeout
          })
        });
      },
      info: t2 => {
        const {
          title: title_0,
          timeout: timeout_0
        } = t2;
        manager.add({
          title: title_0,
          type: "info",
          priority: "low",
          ...(timeout_0 !== undefined && {
            timeout: timeout_0
          })
        });
      },
      success: t3 => {
        const {
          title: title_1,
          timeout: timeout_1
        } = t3;
        manager.add({
          title: title_1,
          type: "success",
          priority: "low",
          ...(timeout_1 !== undefined && {
            timeout: timeout_1
          })
        });
      },
      dismiss: id => manager.close(id)
    };
    $[0] = manager;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}